// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/iconfont.css
// module id = XlLT
// module chunks = 1